import { createModulePerms } from '@wit-support/ui-domain';
export const ADS_LAUNCHER_NO_PERMS = {
    canLaunch: false,
    canActivate: false,
    canForceActivate: false,
    canManageTemplates: false,
    canManageAccounts: false,
    canUpload: false,
    canManageLists: false,
};
const { Provider: AdsLauncherModulePermsProvider, usePerms: useAdsLauncherPerms } = createModulePerms(ADS_LAUNCHER_NO_PERMS);
export { AdsLauncherModulePermsProvider, useAdsLauncherPerms };
/** Флаги прав из списка ключей `me.permissions` — шелл зовёт это вместо ручного маппинга. */
export function adsLauncherPermsFrom(can) {
    return {
        canLaunch: can('ads.launch'),
        canActivate: can('ads.activate'),
        canForceActivate: can('ads.force_activate'),
        canManageTemplates: can('ads.templates_manage'),
        canManageAccounts: can('ads.accounts_manage'),
        canUpload: can('ads.media_upload'),
        canManageLists: can('ads.lists_manage'),
    };
}
//# sourceMappingURL=perms.js.map